<template>
  <footer class="footer-wrap">
    <div class="footer--left"
         v-if="socList.length > 0">
      <a v-for="(row, index) in socList"
         :key="index"
         :href="row.linkAddress"
         target="_blank">
        <span class="icon-svg--type6"
              v-html="row.url" />
      </a>
    </div>

    <div class="footer-right">
      <p>Follow us on TikTok</p>
      @{{ siteDomain }}
    </div>
  </footer>
</template>

<script>
export default {
  name: "pageFooter",

  data() {
    return {
      socList: [],
    }
  },

  computed: {
    siteDomain() {
      if (typeof window === 'undefined') {
        return ''
      }
      return window.location.hostname || ''
    },
  },

  mounted() {
    const homeData = JSON.parse(sessionStorage.getItem('homeData'))
    const obj = homeData.homeContent.links[0]
    this.socList = obj ? [obj] : []
  },
}
</script>

<style scoped lang="scss">
.footer-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 36px;
  border-top: 1px solid hsl(from var(--border-color) h s l / 0.2);

  .footer--left {
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid hsl(from var(--border-color) h s l / 0.2);
    border-radius: 8px;
  }

  .footer--left:hover {
    border: 1px solid hsl(from var(--primary-color) h s l / 0.9);
  }

  .footer-right {
    color: var(--select-color);
    font-size: 14px;
    font-weight: 600;
    letter-spacing: .02em;
    transition: color .2s;

    p {
      color: hsl(from var(--border-color) h s l / 0.4);
      font-size: 10px;
      letter-spacing: .12em;
      text-transform: uppercase;
      font-weight: 400;
    }
  }
}
</style>

<style lang="scss">
.icon-svg--type6 svg {
  display: block;
  height: 18px;
  width: 18px;
  line-height: 32px;
  fill: var(--primary-color);
}
</style>